import { AudioMessage } from "@/composables/use-audio-recorder";

export interface Message {
  role: "user" | "assistant";
  reasonContent: string;
  thoughtContent?: string;
  id: number;
  date: number;
  type: "text" | "greeting";
  audio?: AudioMessage;
  imageList?: string;
  requestId?: number;
  sessionId?: number;
  stageId?: number;
  like?: boolean;
  dislike?: boolean;
  goodsList?: {
    itemDetailJumpUrl: string;
    itemId: number;
    recScore: number;
    extraInfo: string;
  }[];
}

export enum CompleteStatus {
  /** 输出中 */
  COMPLETE = 1,
  /** 输出完成 */
  INCOMPLETE = 2,
  /** 输出错误 */
  ERROR = 4,
}

/** 排序方式 */
export enum SortStrategy {
  /** 默认算法分数 */
  DefaultScore = "DEFAULT_SCORE",
  /** 销量 */
  SaleCount = "SALE_COUNT",
  /** 价格降序 */
  ItemPriceDesc = "ITEM_PRICE_DESC",
  /** 价格升序 */
  ItemPriceAsc = "ITEM_PRICE_ASC",
}
